import { render, staticRenderFns } from "./ComponentGrid.vue?vue&type=template&id=68308dfe&scoped=true&"
import script from "./ComponentGrid.vue?vue&type=script&lang=js&"
export * from "./ComponentGrid.vue?vue&type=script&lang=js&"
import style0 from "./ComponentGrid.vue?vue&type=style&index=0&id=68308dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68308dfe",
  null
  
)

export default component.exports